import { render } from "./AppGlobalModal.vue?vue&type=template&id=600e37d2&scoped=true&ts=true"
import script from "./AppGlobalModal.vue?vue&type=script&lang=ts"
export * from "./AppGlobalModal.vue?vue&type=script&lang=ts"

import "./AppGlobalModal.vue?vue&type=style&index=0&id=600e37d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600e37d2"]])

export default __exports__